/* Collection grid behaviour: filter panel, add to bag, size picker.
   Lifted out of the section's {% javascript %} block to keep that file small
   enough to edit in one request. It already re-initialises itself on
   shopify:section:load, so running as a deferred asset is equivalent.
   Loaded from snippets/stylesheets.liquid. */
(function () {
  var ROOT = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

  function boot(root) {
    if (root.dataset.scClReady) return;
    root.dataset.scClReady = '1';

    var panel = root.querySelector('[data-filters]');

    // The rail hangs off the header rather than off a number written here,
    // reading the header's own custom properties so it stays clear of it
    // whatever inset, announcement height or bar height is set there. This is
    // what was putting the panel under the header on a phone.
    function syncOffsets() {
      var h = document.querySelector('.sc-hd');
      if (!h) return;
      var cs = getComputedStyle(h);
      var inset = cs.getPropertyValue('--inset').trim() || '16px';
      var ann = cs.getPropertyValue('--ann-h').trim() || '30px';
      var bar = cs.getPropertyValue('--bar-h').trim() || '51px';
      root.style.setProperty('--hdr', 'calc(' + inset + ' + ' + ann + ' + ' + bar + ' + 12px)');
      root.style.setProperty('--edge', inset);
    }
    syncOffsets();
    window.addEventListener('resize', syncOffsets);

    // --- filter panel ---------------------------------------------------
    // A full-screen sheet opened from the Filter button. Nothing is applied
    // until Apply: sort and price go to Shopify as its own URL parameters,
    // size is applied here, to the cards already on the page.
    var form = root.querySelector('[data-filter-form]');
    var countEl = root.querySelector('[data-filter-count]');
    var params = new URLSearchParams(window.location.search);

    function openPanel() {
      if (!panel) return;
      syncOffsets();
      panel.hidden = false;
      document.documentElement.classList.add('sc-cl-lock');
      var first = panel.querySelector('input:checked, input');
      if (first) first.focus({ preventScroll: true });
    }
    function closePanel() {
      if (!panel) return;
      panel.hidden = true;
      document.documentElement.classList.remove('sc-cl-lock');
    }
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && panel && !panel.hidden) closePanel();
    });

    // Size: the cards carry the sizes they can be bought in right now.
    var sizes = (params.get('size') || '').split(',').filter(Boolean);
    if (form) {
      form.querySelectorAll('input[name="size"]').forEach(function (i) {
        i.checked = sizes.indexOf(i.value) > -1;
      });
    }
    if (sizes.length) {
      var shown = 0;
      root.querySelectorAll('[data-card]').forEach(function (card) {
        var have = card.getAttribute('data-sizes-in') || '';
        var ok = sizes.some(function (z) { return have.indexOf('|' + z + '|') > -1; });
        card.classList.toggle('is-out', !ok);
        if (ok) shown++;
      });
      var none = root.querySelector('[data-filter-none]');
      if (none) none.hidden = shown > 0;
    }

    // Price: two thumbs on one line, read back from the URL.
    var price = root.querySelector('[data-price]');
    var pMin, pMax, pLo, pHi, pFill, pCap = 0, cur = '';
    if (price) {
      pCap = Number(price.getAttribute('data-max')) || 0;
      cur = price.getAttribute('data-cur') || '';
      pMin = price.querySelector('[data-price-min]');
      pMax = price.querySelector('[data-price-max]');
      pLo = price.querySelector('[data-price-lo]');
      pHi = price.querySelector('[data-price-hi]');
      pFill = price.querySelector('[data-price-fill]');
      var gte = params.get('filter.v.price.gte');
      var lte = params.get('filter.v.price.lte');
      if (gte !== null) pMin.value = Math.max(0, Math.min(pCap, Math.floor(Number(gte))));
      if (lte !== null) pMax.value = Math.max(0, Math.min(pCap, Math.ceil(Number(lte))));
      var paintPrice = function (moved) {
        var lo = Number(pMin.value), hi = Number(pMax.value);
        if (lo > hi) {
          if (moved === pMin) { pMin.value = hi; lo = hi; } else { pMax.value = lo; hi = lo; }
        }
        pLo.textContent = cur + lo;
        pHi.textContent = cur + hi;
        if (pFill && pCap) {
          pFill.style.left = (lo / pCap * 100) + '%';
          pFill.style.right = (100 - hi / pCap * 100) + '%';
        }
      };
      pMin.addEventListener('input', function () { paintPrice(pMin); });
      pMax.addEventListener('input', function () { paintPrice(pMax); });
      paintPrice();
    }

    // How many filters are in force, on the button.
    if (countEl) {
      var n = sizes.length;
      params.forEach(function (v, k) {
        if (k.indexOf('filter.') === 0 && k.indexOf('filter.v.price') !== 0) n++;
      });
      if (params.get('filter.v.price.gte') || params.get('filter.v.price.lte')) n++;
      countEl.textContent = n;
      countEl.hidden = n === 0;
    }

    if (form) {
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        var out = new URLSearchParams();
        var sort = form.querySelector('input[name="sort_by"]:checked');
        if (sort && sort.value !== form.getAttribute('data-sort-default')) out.append('sort_by', sort.value);
        form.querySelectorAll('input[type="checkbox"]:checked').forEach(function (i) {
          if (i.name !== 'size') out.append(i.name, i.value);
        });
        if (price) {
          if (Number(pMin.value) > 0) out.append('filter.v.price.gte', pMin.value);
          if (Number(pMax.value) < pCap) out.append('filter.v.price.lte', pMax.value);
        }
        var picked = [];
        form.querySelectorAll('input[name="size"]:checked').forEach(function (i) { picked.push(i.value); });
        if (picked.length) out.append('size', picked.join(','));
        var q = out.toString();
        window.location.href = window.location.pathname + (q ? '?' + q : '');
      });
    }

    root.addEventListener('click', function (e) {
      if (e.target.closest('[data-filter-open]')) { openPanel(); return; }
      if (e.target.closest('[data-filter-close]')) { closePanel(); return; }
      if (e.target.closest('[data-filter-reset]')) { window.location.href = window.location.pathname; return; }

      // --- add to bag -------------------------------------------------
      var add = e.target.closest('[data-add]');
      if (add) {
        e.preventDefault();
        var card = add.closest('[data-card]');
        if (add.dataset.single === 'true') {
          addToCart(add.dataset.variant, add);
        } else {
          var sizes = card.querySelector('[data-sizes]');
          if (sizes) sizes.hidden = !sizes.hidden;
        }
        return;
      }

      var size = e.target.closest('.sc-cl__size');
      if (size && size.dataset.variant) {
        e.preventDefault();
        addToCart(size.dataset.variant, size);
      }
    });

    function addToCart(id, btn) {
      var was = btn.textContent;
      btn.textContent = '...';
      fetch(ROOT + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: [{ id: Number(id), quantity: 1 }] })
      })
        .then(function (r) { return r.json(); })
        .then(function () {
          return fetch(ROOT + 'cart.js').then(function (r) { return r.json(); });
        })
        .then(function (cart) {
          // Re-publish the storefront event the drawer already listens for,
          // so the cart opens and the header count updates.
          var ev = new Event('shopify:cart:lines-update', { bubbles: true });
          ev.action = 'add';
          ev.context = 'collection';
          ev.promise = Promise.resolve({ cart: { totalQuantity: cart.item_count } });
          document.dispatchEvent(ev);
          btn.textContent = was;
          var sizes = btn.closest('[data-sizes]');
          if (sizes) sizes.hidden = true;
        })
        .catch(function () { btn.textContent = was; });
    }
  }

  function init() { document.querySelectorAll('.sc-cl').forEach(boot); }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', init);
})();
